import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { TableauUserFragmentGql } from './TableauUserFragmentGql';

export const DataQualityWarningFragmentGql: DocumentNode = gql`
fragment DataQualityWarningFragment on DataQualityWarning {
  vizportalId
  isActive
  isSevere
  warningType
  message
  updatedAt
  authorDisplayName
  author {
    ...TableauUserFragment
  }
}
${TableauUserFragmentGql}
`;
